export default "__VITE_ASSET__D68S6n2v__"